import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

/**
 * Checks if the user is already logged in.
 * @author Brayan Cataño
 * @description Checks for token in localStorage, if it is, navigates the user to the home page.
 * If the token is not present means that the user is not logged in, returns false in this scenario.
 * @returns {boolean} Returns boolean meaning the presence of jWT token in session storage
 */
export const alreadyLoggedInGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const gaurdActive = sessionStorage.getItem('authenticated') === 'true' || !!sessionStorage.getItem('token');
  if(gaurdActive){
    router.navigate(['/']);
    return false;
  }else{
    return true;
  }
};
